export default __webpack_public_path__ + "static/134-95cad06b3f2788bd978abe6b57144928.gif";